<template>
  <div class="wrapper" :class="classObj">
    <Header />
    <FloatingMenu />
    <app-main></app-main>
    <Footer />
  </div>
</template>

<script>
import { AppMain, Header, Footer, FloatingMenu } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'vueLayout',
  components: {
    FloatingMenu,
    // eslint-disable-next-line vue/no-reserved-component-names
    Header,
    AppMain,
    // eslint-disable-next-line vue/no-reserved-component-names
    Footer
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../styles/mixin.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue